import Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import "./tableUsers.styl";
import {Routes} from "../../../router";
import {ConfigService} from "../../../helpers/services/configService";
import {UtilsService} from "../../../helpers/services/utilsService";
import {LanguageManager} from "../../../languages/languages";
import {UserList} from "../../../models/user";
import {eventBus, signalNames} from "../../../bus";
import * as moment from "moment";
import {application} from "../../../stores/application";
const template = require("./tableUsers.vue");

interface PaginationObject {
  rowsPerPage: number;
  page: number;
}
@Component({
  template: template
})
export default class TableUsersComponent extends Vue {

  users: any = [];
  search: string = "";
  searchKind = "all";
  userKinds = [
    { text: "Tutti", value: "all" },
    { text: "Admin", value: "admin" },
    { text: "Ospite", value: "guest" },
  ];
  loading: boolean = false;
  text: string = "";
  totalItems = 0;
  pagination: PaginationObject = {
    rowsPerPage: 10,
    page: 1,
  };

  headers = [
    { text: LanguageManager.instance.i18n.t("automationUser"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUserEmail"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUserType"), align: "left", sortable: false },
    // { text: LanguageManager.instance.i18n.t("automationUuid"), align: "left", sortable: false }
  ];

  @Watch("search")
  searchHandler() {
    this.handleSearchFilters();
  }

  @Watch("searchKind")
  searchKindHandler() {
    this.handleSearchFilters();
  }

  @Watch("pagination", { deep: true })
  paginationHandler() {
    console.warn("pagination watcher");

    const { page, rowsPerPage } = this.pagination;
    const query = `?page=${page}&per_page=${rowsPerPage}${this.getSearchQuery()}`;
    this.refreshAutomations(query);
  }

  created() {
    this.text = "Loading...";
    const { rowsPerPage } = this.pagination;
    const query = `?page=1&per_page=${rowsPerPage}${this.getSearchQuery()}`;
    this.refreshAutomations(query);
    eventBus.$emit(signalNames.setToolbarOptions, {
      title: LanguageManager.instance.i18n.t("usersRequests"),
      reloadAction: () => this.refreshAutomations(query)
    });
  }
  
  getSearchQuery() {
    if (this.search.length === 0)
      return `&type=${this.searchKind}`;
    return `&q=${encodeURIComponent(this.search)}&type=${this.searchKind}`;
  }

  handleSearchFilters() {
    const { rowsPerPage } = this.pagination;
    const query = `?page=1&per_page=${rowsPerPage}${this.getSearchQuery()}`;
    if (this.search.length > 1) {
      this.refreshAutomations(query);
    } else if (this.search.length === 0) {
      this.refreshAutomations(query);
    }
  }
  refreshAutomations(query) {
    this.loading = true;
    application.commitStartLoader(this.$store);
    // this.users = null;
    Vue.http.get(ConfigService.users + "/list" + query, {})
      .then(response => {
        this.loading = false;
        console.log("user: ", response.data.data);
        this.users = response.data.data.map(user => new UserList().deserialize(user).makeUserType().flatten());
        this.totalItems = Number(response.data.metadata.total_count);
        console.log("user: ", this.users);
        application.commitStopLoader(this.$store);
      })
      .catch(error => {
        this.loading = false;
        application.commitStopLoader(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }

  compare(var1: string, var2: string): boolean {
    if (var1) return var1.toLowerCase().indexOf(var2.toLowerCase()) !== -1 ;
    return false;
  }

  handleClickUser(userId) {
    // console.log("ECCOMI");
    this.$router.push({name: Routes.userDetail.name,  params: { id: userId }});
  }

  getDescriptionFromDateTime(date: string, time: string): string {
    return UtilsService.instance.getDescriptionFromDateTime(date, time);
  }
  getAvatar(rawVehicle: any): string {
    // const vehicle = new Vehicle().deserialize(rawVehicle);
    // return vehicle.getPicture();
    return "";
  }

}

Vue.component("cmTableUsers", TableUsersComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/tableUsers/tableUsers.ts